import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["track", "slide", "dot", "prevLabel", "nextLabel"]

  connect() {
    this.currentIndex = 0
    this._collectTitles()
    this._updateNavLabels()
    this.startAutoplay()

    this.element.addEventListener("mouseenter", () => this.stopAutoplay())
    this.element.addEventListener("mouseleave", () => this.startAutoplay())

    // Recalculate on resize
    this._onResize = () => this.goToIndex(this.currentIndex)
    window.addEventListener("resize", this._onResize)

    // Touch/swipe support for mobile
    this._touchStartX = 0
    this._touchEndX = 0
    this.trackTarget.addEventListener("touchstart", (e) => {
      this._touchStartX = e.changedTouches[0].screenX
      this.stopAutoplay()
    }, { passive: true })

    this.trackTarget.addEventListener("touchend", (e) => {
      this._touchEndX = e.changedTouches[0].screenX
      this.handleSwipe()
      this.startAutoplay()
    }, { passive: true })
  }

  disconnect() {
    this.stopAutoplay()
    window.removeEventListener("resize", this._onResize)
  }

  handleSwipe() {
    const diff = this._touchStartX - this._touchEndX
    if (Math.abs(diff) < 50) return // minimum swipe distance
    if (diff > 0) this.next()
    else this.prev()
  }

  next() {
    this.goToIndex((this.currentIndex + 1) % this.slideTargets.length)
  }

  prev() {
    this.goToIndex((this.currentIndex - 1 + this.slideTargets.length) % this.slideTargets.length)
  }

  goTo(event) {
    const index = parseInt(event.currentTarget.dataset.index)
    this.goToIndex(index)
  }

  goToIndex(index) {
    this.currentIndex = index
    const viewportWidth = this.trackTarget.parentElement.offsetWidth
    this.trackTarget.style.transform = `translateX(-${index * viewportWidth}px)`

    this.dotTargets.forEach((dot, i) => {
      dot.classList.toggle("carousel__dot--active", i === index)
    })

    this._updateNavLabels()
  }

  _collectTitles() {
    this._titles = this.slideTargets.map(slide => {
      const el = slide.querySelector(".carousel__title")
      return el ? el.textContent.trim() : ""
    })
  }

  _updateNavLabels() {
    const total = this.slideTargets.length
    if (!total) return
    const prevIndex = (this.currentIndex - 1 + total) % total
    const nextIndex = (this.currentIndex + 1) % total

    if (this.hasPrevLabelTarget) {
      this.prevLabelTarget.textContent = this._titles[prevIndex].substring(0, 25)
    }
    if (this.hasNextLabelTarget) {
      this.nextLabelTarget.textContent = this._titles[nextIndex].substring(0, 25)
    }
  }

  startAutoplay() {
    this.stopAutoplay()
    this.timer = setInterval(() => this.next(), 6000)
  }

  stopAutoplay() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
